import { usePathname } from 'next/navigation';
import styled from 'styled-components';
import { SheetHead, theme } from '@frameio/vapor';
import { Navigation } from '@frameio/workspaces/navigation/Navigation';
import { WorkspacesNavStandalone } from '@frameio/workspaces/shared/components/WorkspacesNav/WorkspacesNavStandalone';
import TEXT from './generated/TEXT/WorkspacesNavigationSheet';

type Props = {
  onItemSelected?: () => void;
};

export const WorkspacesNavSheet = ({ onItemSelected }: Props) => {
  const pathname = usePathname();
  const isMegapriseWorkspaces =
    pathname === '/' || pathname.split('/')[1] === 'workspaces';

  return (
    <>
      <SheetHead
        title={isMegapriseWorkspaces ? TEXT.titleHome : TEXT.titleWorkspaces}
      />
      {isMegapriseWorkspaces ? (
        <Container>
          <Navigation onItemSelected={onItemSelected} />
        </Container>
      ) : (
        <WorkspacesNavStandalone />
      )}
    </>
  );
};

// Shrink the navigation container by the height of the SheetHead
const Container = styled.div`
  height: calc(100% - ${theme.spaces[48]});
`;

TEXT.DEFINE({
  /** Sheet title shown when viewing the workspaces navigation */
  titleWorkspaces: 'Workspaces',
  /** Sheet title shown when the homepage navigation is enabled */
  titleHome: 'Home',
});
